// @flow
import React from 'react';

import { StaticTable } from '../presentational/StaticTable';

export const TableflowTierPricingTable = () => {
  const tableContents = {
    headerRow: ['Tier Name', 'Topics consumed', 'Topic-hrs per month', 'Effective discount'],
    dataRows: [
      ['First 1 - 10 topics', '10', '7300', '0%'],
      ['Next 11 - 50', '40', '29200', '20%'],
      ['Next 51 - 100', '50', '36500', '40%'],
      ['Next 101 - 250', '150', '109500', '60%'],
      ['Next 251 - 1,000', '750', '547500', '75%'],
      ['Next 1,000+', '', '', '90%'],
    ],
  };
  return <StaticTable tableContents={tableContents} />;
};
